<agpr-master-layout [id]="id">
    <!-- Don't show the sidebar -->
    <ng-template agprTemplate="navigation">
    </ng-template>
</agpr-master-layout>
